/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Description1Inputs */

const he_ratelimit_description1 = /** @type {(inputs: Ratelimit_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קצת מהיר מדי בשבילנו. המתן רגע ונסה שוב.`)
};

const en_ratelimit_description1 = /** @type {(inputs: Ratelimit_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A bit too quick for us. Give it a moment and try again.`)
};

/**
* | output |
* | --- |
* | "A bit too quick for us. Give it a moment and try again." |
*
* @param {Ratelimit_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_description1 = /** @type {((inputs?: Ratelimit_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_description1(inputs)
	return en_ratelimit_description1(inputs)
});
export { ratelimit_description1 as "rateLimit_description" }